'use strict';

var settingsCtrl = function ($scope, railApi, $stateParams, $rootScope) {

    // List of IANA time zones (from Intl support)
    $scope.zones = [];
    if (typeof Intl.supportedValuesOf === 'function') {
        $scope.zones = [
                            { id: "America/St_Johns", name: "Newfoundland Time (St. John's)"},
                            // { id: "America/Halifax", name: "Atlantic Time (Halifax)"},
                            { id: "America/Moncton", name: "Atlantic Time (Moncton)"},
                            { id: "America/Toronto", name: "Eastern Time (Toronto)"},
                            { id: "America/Winnipeg", name: "Central Time (Winnipeg)"},
                            { id: "America/Regina", name: "Central Time (Regina - No DST)"},
                            { id: "America/Edmonton", name: "Mountain Time (Edmonton)",},
                            { id: "America/Vancouver", name: "Pacific Time (Vancouver)"},
                            { id: "America/Whitehorse", name: "Mountain Time (Whitehorse - No DST)"},
                        ];
    } else {
        // Minimal fallback list if Intl.supportedValuesOf is not available
        $scope.zones = ["UTC"];
    }

    // Function to get UTC offset
    $scope.getUTCOffset = function(timeZone) {
        var now = new Date();
        var formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            timeZoneName: 'shortOffset'
        });
        var parts = formatter.formatToParts(now);
        var offsetPart = parts.find(function(p) { return p.type === 'timeZoneName'; });
        var offsetValue = (offsetPart && offsetPart.value) ? offsetPart.value : '';
        return offsetValue.replace('GMT', 'UTC');
    }

    // Build array for ng-repeat
    $scope.timeZones = $scope.zones.map(function(tz) {
        return {
            name: tz.name,
            id: tz.id,
            offset: $scope.getUTCOffset(tz.id)
        };
    });
        
    $scope.colorPadding = function () {
        if($scope.ieDetector == true){
            return {"padding": ""};
        } else {
            return {"padding": "2px"};
        }
    }

    $scope.updateDefaultSort = function (defaultSort) {
        $rootScope.clientSettings.candidate_default_sort = defaultSort
    }
};



module.exports = settingsCtrl;
